import script from "./ViewSectorsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSectorsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewSectorsPage.vue?vue&type=style&index=0&id=2ced0cd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ced0cd8"]])

export default __exports__